import { HistoryItem } from './topup.interface'

export interface CreateCarAgency {
  name: string
  email: string
  phone: string
  address: string
  image: File | null
}

export interface CarAgency {
  name: string
  uuid: string
  email: string
  phone: string
  address: string
  is_active: true
  image: string | null
  created_at: string
  updated_at: string
}

export interface CreateCarCategory {
  name: string
  car_agency: string
  description: string
}

export interface CarCategory {
  name: string
  car_agency: string
  uuid: string
  description: string
  car_agency_name: string
  created_at: string
  updated_at: string
}

export interface CreateCarOffice {
  name: string
  car_agency: string
  email: string
  phone: string
  description: string
  is_airport: boolean
  allow_pick_up: boolean
  allow_drop_off: boolean
  schedule: string
  longitude: string
  latitude: string
  address: string
  subregion: number
  region: number
  opening_time: string
  closing_time: string
}

export interface CarOffice {
  name: string
  car_agency: string
  uuid: string
  email: string
  phone: string
  description: string
  car_agency_name: string
  is_active: boolean
  is_airport: boolean
  allow_pick_up: boolean
  allow_drop_off: boolean
  opening_time: string
  closing_time: string
  longitude: string
  latitude: string
  address: string
  subregion: number
  subregion_name: string
  region: number
  region_name: string
  created_at: string
  updated_at: string
}

export interface CreateCarSeason {
  name: string
  start_datetime: string
  end_datetime: string
  description: string
}

export interface CarSeason {
  name: string
  start_datetime: string
  end_datetime: string
  uuid: string
  description: string
  created_at: string
  updated_at: string
}

export enum CarBookingStatus {
  REQUESTED = 'REQUESTED',
  CONFIRMED = 'CONFIRMED',
  CANCELED = 'CANCELED',
}

export interface CarBooking {
  uuid: string
  code: string
  cost: string
  price: string
  booking: string
  pick_office: string
  pick_office_name: string
  pick_in_airport: boolean
  drop_office: string
  drop_office_name: string
  start_datetime: string
  end_datetime: string
  from_agency: string
  from_agency_name: string
  agency: string
  agency_name: string
  history: HistoryItem
  description: string
  status: CarBookingStatus
  created_at: string
  updated_at: string
  created_by: string
  original_agency: string
  pdf_sent: boolean
  flight: string
  flight_terminal: string
  flight_datetime: string
}
export interface CreateCarBooking {
  client: {
    identity: string
    first_name: string
    last_name: string
    nationality: number
    email: string
    phone: string
  }
  pick_office: string
  drop_office: string
  start_datetime: string
  end_datetime: string
  price: string
  category: string
  description: string
  agency: string
  flight: string
  flight_code: string
  flight_terminal: string
  flight_datetime: string
}

export interface CarPriceConfig {
  agency: string
  min_amount: string
  max_amount: string
  percent: string
  uuid: string
  agency_name: string
  is_active: boolean
  created_at: string
  updated_at: string
  can_create_rental_contract: boolean
}

export interface CreateCarPriceConfig {
  agency: string
  min_amount: string
  max_amount: string
  percent: string
  can_create_rental_contract: boolean
}

export interface CreateCarClient {
  first_name: string
  last_name: string
  nationality: number
  email: string
  phone: string
  identity: string
}

export interface CarClient {
  uuid: string
  first_name: string
  last_name: string
  nationality: number
  nationality_name: string
  email: string
  phone: string
  identity: string
}

export interface CarContract {
  agency: string
  agency_name: string
  car_agency: string
  car_agency_name: string
  created_at: string
  description: string
  end_date: string
  is_active: boolean
  name: string
  offices: string[]
  parent: string
  prices: CarContractPrice[]
  start_date: string
  updated_at: string
  uuid: string
}

export interface CreateCarContract {
  agency: string
  car_agency: string
  description: string
  end_date: string
  name: string
  offices: string[]
  prices: CreateCarContractPrice[]
  start_date: string
}

export interface CreateCarContractPrice {
  category: string
  cost: string
  max_days: number
  min_days: number
  price: string
  season: string
}

export interface CarContractPrice {
  category: string
  category_name: string
  cost: string
  created_at: string
  max_days: number
  min_days: number
  price: string
  season: string
  season_name: string
  updated_at: string
  uuid: string
}

export interface ContractSharedPrice {
  category: string
  category_name: string
  contract: string
  cost: string
  created_at: string
  max_days: number
  min_days: number
  season: string
  season_name: string
  updated_at: string
  uuid: string
}

export interface CreateContractSharedPrice {
  category: string
  contract: string
  cost: string
  max_days: number
  min_days: number
  season: string
}
export interface ContractSharedPrice {
  category: string
  category_name: string
  contract: string
  cost: string
  created_at: string
  max_days: number
  min_days: number
  season: string
  season_name: string
  updated_at: string
  uuid: string
}

export interface CreateContractSharedPrice {
  category: string
  contract: string
  cost: string
  max_days: number
  min_days: number
  season: string
}

export interface ContractPrice {
  category: string
  category_name: string
  contract: string
  cost: string
  price: string
  created_at: string
  max_days: number
  min_days: number
  season: string
  season_name: string
  updated_at: string
  uuid: string
}

export interface CreateContractPrice {
  category: string
  contract: string
  cost: string
  price: string
  max_days: number
  min_days: number
  season: string
}

export interface CarSearchCategory {
  category: string
  category_name: string
  price: string
  price_per_day: number
  total_price: number
}

export interface CarSearch {
  total_days: number
  pick_up_office: string
  pick_up_office_name: string
  drop_off_office: string
  drop_off_office_name: string
  pick_up_datetime: string
  drop_off_datetime: string
  categories: CarSearchCategory[]
}
